import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} anonym chatt för Norden och Baltikum`,
    languageButtonLabel: `Språk`,
    languageModalTitle: `Välj språk`,
    languageModalCloseLabel: `Stäng språkmeny`,
  },
  languageOptions: {
    'en-US': {
      label: `Engelska (USA)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Engelska (Kenya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Engelska (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Engelska (Singapore)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugisiska (Portugal)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portugisiska (Brasilien)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Tyska (Tyskland)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Tyska (Österrike)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Tyska (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spanska (Spanien)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Franska (Frankrike)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italienska (Italien)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Nederländska (Nederländerna)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polska (Polen)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Svenska (Sverige)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Danska (Danmark)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Finska (Finland)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norska (Norge)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Isländska (Island)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japanska (Japan)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Koreanska (Sydkorea)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Kinesiska (Kina)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kantonesiska (Hongkong SAR)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnamesiska (Vietnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thailändska (Thailand)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonesiska (Indonesien)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Swahili (Kenya)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi (Indien)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengali (Bangladesh)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marathi (Indien)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu (Indien)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persiska (Iran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Punjabi (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Nigeriansk pidgin (Nigeria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Ryska (Ryssland)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabiska (Saudiarabien)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arabiska (Förenade Arabemiraten)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arabiska (Qatar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Marockansk arabiska (Marocko)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Turkiska (Turkiet)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Välj språk`,
    closeLabel: `Stäng språkmeny`,
  },
  languageHint: (ctx) => `Hoppa mellan ${ctx.localesCount}+ språk utan att skapa konto.`,
  readPagePrompt: ({languageLabel}) => `Läs den här sidan på ${languageLabel}.`,
};
